export const getQuantityForCompanySize = (size: string) => {
  const range = size.split('-');
  if (range.length === 2 && range[1].match(/^\d+$/)) {
    return parseInt(range[1], 10);
  } else {
    return parseInt(range[0].replace(/\D/g, ''), 10);
  }
};
